/* ============================================================
   SETTINGS → MY PLAN → KAD "PRO STUDIO" (claim percuma ikut ciri)
   ============================================================
   Keputusan user 2026-09-26 (lakaran diluluskan dalam chat): kad
   menyenaraikan ciri PRO Studio dengan status setiap satu + butang
   claim terus dari sini. Agent Saya dipapar sebagai "ikut module
   SMART" (tidak termasuk percuma). Ciri belum siap = "Akan datang".

   `modSebenar=false` (/settings-v3.9) → data contoh, tiada tulisan.
   ============================================================ */

import { useState } from 'react';
import { Sparkles } from 'lucide-react';

import { Badge, Btn, Card, CardBody } from '../design/ui';
import { useCiriPercuma } from '../hooks/useCiriPercuma';
import PopupCiriPercuma from './PopupCiriPercuma';
import { CIRI, rekodCiri, formatTarikh } from '../utils/ciriPercuma';

export default function KadProStudioPercuma({ modSebenar = false, t, bahasa = 'ms' }) {
    const ciriP = useCiriPercuma(modSebenar);
    const [popup, setPopup] = useState(null);

    const statusDemo = { [CIRI.SHORTCUT]: 'aktif', [CIRI.CTA]: 'belum' };
    const status = (c) => (modSebenar ? ciriP.status(c) : statusDemo[c]);

    const lencana = (c) => {
        const st = status(c);
        if (st === 'admin') return <Badge tone="brand">{t('ciri.st.admin')}</Badge>;
        if (st === 'aktif') {
            const { sehingga } = modSebenar ? rekodCiri(ciriP.ciriPercuma, c) : { sehingga: new Date('2026-11-30T23:59:59+08:00') };
            return <Badge tone="ok">{t('ciri.st.aktif', { tarikh: formatTarikh(sehingga, bahasa) })}</Badge>;
        }
        if (st === 'tamat') return <Badge tone="neutral">{t('ciri.st.tamat')}</Badge>;
        return (
            <Btn size="sm" variant="ghost" onClick={() => modSebenar && setPopup(c)}>
                {t('ciri.activate')}
            </Btn>
        );
    };

    const baris = (label, kanan, pudar = false) => (
        <div style={{
            display: 'flex', alignItems: 'center', gap: 10, padding: '11px 0',
            borderTop: '1px solid var(--s-line)',
        }}>
            <span style={{ flex: 1, fontSize: 14, color: pudar ? 'var(--s-ink-3)' : 'var(--s-ink)' }}>{label}</span>
            {kanan}
        </div>
    );

    return (
        <Card style={{ marginBottom: 16 }}>
            <CardBody>
                <h3 className="s-cardname" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Sparkles size={16} strokeWidth={1.9} /> PRO Studio
                </h3>
                <p className="s-dim" style={{ marginTop: 3, marginBottom: 12 }}>{t('ciri.myplan.desc')}</p>
                {baris('Shortcut /', lencana(CIRI.SHORTCUT))}
                {baris(t('ciri.myplan.cta'), lencana(CIRI.CTA))}
                {baris(t('prostudio.section.agent.label'), <Badge tone="neutral">{t('ciri.myplan.agentSmart')}</Badge>)}
                {baris(t('ciri.myplan.soonList'), <Badge tone="neutral">{t('prostudio.soon')}</Badge>, true)}
            </CardBody>
            {popup && <PopupCiriPercuma ciri={popup} onTutup={() => setPopup(null)} t={t} />}
        </Card>
    );
}
